import * as React from 'react';
import {useState} from "react";

import { useStyles } from './styles';
import {
    Box,
    Button,
    Checkbox,
    FormControl,
    FormControlLabel,
    InputLabel,
    MenuItem,
    Select,
} from "@mui/material";
import { Panel } from '../ui';
import StoryImage from "./StoryImage";
import StoryVideo from "./StoryVideo";
import StoryImages from "./StoryImages";
import {IOneStory} from "../../store/types";
import {Stories} from '../../store/slices'
import {useDispatch} from "react-redux";
import Skeleton from "@mui/material/Skeleton";



const StoryStatus = [
     {status: 'Created', color:'#00ccff54', value:1},
     {status: 'Pending review', color:'#ffa500ab', value:2},
     {status: 'Approved', color:'#4bd30899', value:3},
     {status: 'Rejected', color:'#80808073', value:4},
     {status: 'Test Data', color:'#ff000073', value:5},
     {status: 'Error on review', color:'#ff000073', value:6},
]

const ProductVariants = [
    {title: 'Small', value: 1},
    {title: 'Medium', value: 2},
    {title: 'Large', value: 3},
    {title: 'Mini', value: 7},
    {title: 'Keychain', value: 4},
    {title: 'Square', value: '5,6,10'},
    {title: 'Extra Large', value: 11},
]

const StoryOccasion = [
    {title: 'Birthday Gift', value: 1},
    { title: 'Christmas Gift', value: 2 },
    { title: 'Father’s Day Gift', value: 3 },
    { title: 'Graduation Gift', value: 4 },
    { title: 'Mother’s Day Gift', value: 5 },
    { title: 'Wedding Gift', value: 6 },
    { title: 'Back To College Gift', value: 7 },
    { title: 'Passing of pet', value: 8 },
    { title: 'Other', value: 9 },
    { title: 'Valentines day Gift', value: 10 },
    { title: 'Anniversary Gift', value: 11 },
    { title: 'Graduation Gift', value: 12 },
    { title: 'Pride Month Gift', value: 13 },
    { title: 'Easter Gift', value: 14 },
    { title: 'Memorial Day Gift', value: 15 },
    { title: '4th Of July Gift', value: 16 },
    { title: 'Halloween Gift', value: 17 },
    { title: 'Thanksgiving Gift', value: 18 },
    { title: 'New Year’s Gift', value: 19 },
    { title: 'Baby Shower Gift', value: 20 },
    { title: 'Housewarming Gift', value: 21 },
    { title: 'Retirement Gift', value: 22 },
    { title: 'Engagement Gift', value: 23 },
    { title: 'Promotion Gift', value: 24 },
    { title: 'Back To School Gift', value: 25 },
    { title: 'Sports Achievements Gift', value: 26 },
    { title: 'Memorial Gift', value: 27 }
]

const StoryRecipient = [
    { title: 'Prefer not to answer', value: 1 },
    { title: 'Son', value: 2 },
    { title: 'Daughter', value: 3 },
    { title: 'Parent', value: 4 },
    { title: 'Friend', value: 5 },
    { title: 'Co-Worker', value: 6 },
    { title: 'Grandparent', value: 7 },
    { title: 'Myself', value: 8 },
    { title: 'Spouse', value: 9 },
    { title: 'Boyfriend/Girlfriend', value: 10 },
    { title: 'Child', value: 11 },
    { title: 'Other', value: 12 }
]



export default function StoryForm(props: any) {
    const { data } = props.data;
    const [formData, setFormData] = useState<IOneStory>({})
    const [pending, setPending] = useState(false);
    const classes = useStyles();

    const dispatch = useDispatch()
    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setPending(true);
        const updatedFormData = {
            ...formData,
            ...(formData.productId !== undefined && {
                productId: typeof formData.productId === 'string' && formData.productId === '5,6,10' ? 6 : formData.productId
            })
        };
        dispatch<any>(Stories.updateStory({id: data.storyId, formData: updatedFormData})).then(() => {
            setFormData({});
            setPending(false);
        });
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    }
    const handleCheckBoxChange = (e) => {
        const { name, checked } = e.target;
        setFormData({
            ...formData,
            [name]: checked ? 1 : 0,
        });
    }
    const dirty = Object.keys(formData).length !== 0;

    return (
        <Panel title="Story" subtitle={dirty ? 'Unsaved changes' : undefined} footer={dirty ? (
            <div className={classes.buttonWrap}>
                <Button variant="text" onClick={() => setFormData({})} disabled={pending}>Discard changes</Button>
                <Button type="submit" form="story-edit-form" variant="contained" disabled={pending}>Save changes</Button>
            </div>
        ) : undefined}>
            <div className={classes.wrapper}>
            {pending && <div className={classes.giftCardLoader}> <Skeleton animation="wave" width={'100%'} height={'100%'} variant="rounded" /></div>}
            <Box component="form" id="story-edit-form" onSubmit={handleSubmit} noValidate className={classes.formContainer}>
                
                {/* Meta Data Section */}
                <div className={classes.metaDataSection}>
                    <FormControl variant="outlined" size="small">
                        <InputLabel>Product</InputLabel>
                        <Select
                            value={formData?.productId || ((data.productId === 5 || data.productId === 6 || data.productId === 10) ? '5,6,10' : data.productId) || 1}
                            label="Product"
                            name="productId"
                            onChange={handleInputChange}
                        >
                            {ProductVariants.map((product) =>
                                <MenuItem key={`${product.value}${product.title}`} value={(product.value === 5 || product.value === 6 || product.value === 10) ? '5,6,10' : product.value}>{product.title}</MenuItem>
                            )}
                        </Select>
                    </FormControl>

                    <FormControl variant="outlined" size="small">
                        <InputLabel>Status</InputLabel>
                        <Select
                            value={formData.statusId || data.statusId || 1}
                            label="Status"
                            name="statusId"
                            onChange={handleInputChange}
                        >
                            {StoryStatus.map((story) =>
                                <MenuItem key={`${story.value}${story.status}`} value={story.value}>{story.status}</MenuItem>
                            )}
                        </Select>
                    </FormControl>

                    <FormControl variant="outlined" size="small">
                        <InputLabel>Occasion</InputLabel>
                        <Select
                            value={formData.occasionId || data.occasionId || 1}
                            label="Occasion"
                            name="occasionId"
                            onChange={handleInputChange}
                        >
                            {StoryOccasion.map((occasion) =>
                                <MenuItem key={`${occasion.value}${occasion.title}`} value={occasion.value}>{occasion.title}</MenuItem>
                            )}
                        </Select>
                    </FormControl>

                    <FormControl variant="outlined" size="small">
                        <InputLabel>Recipient</InputLabel>
                        <Select
                            value={formData.recipientId || data.recipientId || 1}
                            label="Recipient"
                            name="recipientId"
                            onChange={handleInputChange}
                        >
                            {StoryRecipient.map((recipient) =>
                                <MenuItem key={`${recipient.value}${recipient.title}`} value={recipient.value}>{recipient.title}</MenuItem>
                            )}
                        </Select>
                    </FormControl>

                    <FormControlLabel 
                        control={<Checkbox defaultChecked={data.isPublished === 1} onChange={handleCheckBoxChange} name="isPublished" />} 
                        label="Show Page" 
                    />
                </div>

                {/* Media Section */}
                <div className={classes.mediaSection}>
                    <div className={classes.mediaRow}>
                        <div className={classes.sectionLabel}>Main Media</div>
                        <StoryImage 
                            name="imageLink" 
                            value={formData.imageLink || data.imageLink} 
                            onChange={handleInputChange} 
                            label="Main Image" 
                        />
                        <StoryVideo 
                            name="videoLink" 
                            value={formData.videoLink || data.videoLink} 
                            onChange={handleInputChange} 
                            label="Main Video" 
                        />
                    </div>

                    <div className={classes.mediaRow}>
                        <div className={classes.sectionLabel}>Secondary Media</div>
                        <StoryImage 
                            name="imageLinkSecondary" 
                            value={formData.imageLinkSecondary || data.imageLinkSecondary} 
                            onChange={handleInputChange} 
                            label="Secondary Image" 
                        />
                        <StoryVideo 
                            name="videoLinkSecondary" 
                            value={formData.videoLinkSecondary || data.videoLinkSecondary} 
                            onChange={handleInputChange} 
                            label="Secondary Video" 
                        />
                    </div>

                    <div className={classes.mediaRow}>
                        <div className={classes.sectionLabel}>Production Media</div>
                        <StoryImage 
                            name="imageLinkProduction" 
                            value={formData.imageLinkProduction || data.imageLinkProduction} 
                            onChange={handleInputChange} 
                            label="Production Image" 
                        />
                        <StoryVideo 
                            name="videoLinkProduction" 
                            value={formData.videoLinkProduction || data.videoLinkProduction} 
                            onChange={handleInputChange} 
                            label="Production Video" 
                        />
                    </div>

                    <div className={classes.mediaRow}>
                        <div className={classes.sectionLabel}>Story Images</div>
                        <StoryImages 
                            name="storyImages" 
                            value={formData.storyImages || data.storyImages} 
                            onChange={handleInputChange} 
                        />
                    </div>
                </div>

            </Box>
            </div>
        </Panel>
    );
}